import styled from '@emotion/styled';
import { css } from '@emotion/react';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';

import { NoGapSupport } from '../../lib/utils/mixins';

const {
	spacing: {
		size_8px: { height: size_8 }
	}
} = tokens;

export const Counter = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100px;
	gap: ${size_8}px;
`;

export const CounterInputs = styled.div`
	${NoGapSupport(
		() => css`
			margin: 0 ${size_8}px;
		`
	)}
`;
